import {createAction} from '@reduxjs/toolkit';
import {GetPageEditorsDTO} from 'typescript/dto/pageEditorsDto';
import {withPayloadType} from 'typescript/types/PayloadType';

import {pageEditorSliceNamespace} from './pageEditorSlice';

const getPageEditorsACS = createAction(
  `${pageEditorSliceNamespace}/getPageEditorsACS`,
  withPayloadType<GetPageEditorsDTO>(),
);

const getUsersACS = createAction(`${pageEditorSliceNamespace}/getUsersACS`);

export {getPageEditorsACS, getUsersACS};
